module.exports = __webpack_public_path__ + "media/usp-trackers-83991939.svg";